// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';

import type { WizardFieldError } from '../types/wizard';

interface WizardErrorSummaryProps {
  errors: WizardFieldError[];
  // React 19 made `useRef<T>(null)` return `RefObject<T | null>` rather than
  // `RefObject<T>`. Mirror that shape so callers can pass a ref returned
  // directly from `useRef<HTMLDivElement>(null)` without a cast.
  errorSummaryRef?: React.RefObject<HTMLDivElement | null>;
}

export function WizardErrorSummary({ errors, errorSummaryRef }: WizardErrorSummaryProps) {
  if (errors.length === 0) return null;

  return (
    <div ref={errorSummaryRef} role="alert" tabIndex={-1}>
      <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        <p className="font-semibold mb-1">
          <span className="mr-1">{'\u26A0'}</span>
          Please correct the following errors
        </p>
        <ul className="list-disc list-inside mt-1">
          {errors.map((err) => (
            <li key={err.field}>{err.message}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
